<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <el-form label-position="top"
             :inline="true"
             :model="dataForm">
      <el-row class="margb10">
        <el-col :span="5"
                class="padt5">
          <!-- 组织类型 -->
          <el-form-item :label="$t('organization.orgType')"
                        prop="orgType">
            <el-select v-model="dataForm.orgType"
                       clearable
                       @change="changeOrgType"
                       :placeholder="$t('user.select')">
              <el-option v-for="(item,index) in neworgType"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5"
                class="padt5">
          <!-- 所属公司名称 -->
          <el-form-item :label="$t('user.orgAbbreviation')">
            <el-select v-model="dataForm.orgId"
                       remote
                       clearable
                       filterable
                       reserve-keyword
                       :placeholder="$t('user.input')"
                       :remote-method="querySearch">
              <el-option v-for="item in results"
                         :key="item.orgId"
                         :label="item.name"
                         :value="item.orgId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5"
                class="padt5">
          <!-- 品牌 -->
          <el-form-item :label="$t('organization.brandCodes')">
            <el-select v-model="dataForm.brandCode"
                       :placeholder="$t('user.select')"
                       clearable>
              <el-option v-for="(item,index) in brandArr"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5"
                class="padt5">
          <!-- 姓名 -->
          <el-form-item :label="$t('user.name')">
            <el-input v-model="dataForm.userName"
                      :placeholder="$t('user.input')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-col :span="24">
            <el-button class="M-search"
                       style="margin-bottom: 7px"
                       type="primary"
                       @click="getDataListMerge">{{$t('user.query')}}</el-button>
          </el-col>
          <!-- 重置 -->
          <el-col :span="24">
            <el-button class="el-back M-search M-margin-l"
                       type="info"
                       @click="again">{{$t('reset')}}</el-button>
          </el-col>
        </el-col>
      </el-row>
    </el-form>
    <el-form label-position="top"
             :inline="true"
             v-show="isShow">
      <el-row class="margb10">
        <el-col :span="5"
                class="padt5">
          <!-- 在职状态 -->
          <el-form-item :label="$t('user.incumbency')">
            <el-select v-model="dataForm.jobStatus"
                       clearable
                       :placeholder="$t('user.select')">
              <el-option v-for="(item,index) in jobStatus"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5"
                class="padt5">
          <!-- 入职状态 -->
          <el-form-item :label="$t('user.registration')">
            <el-select v-model="dataForm.registrationApprovaStatus"
                       clearable
                       :placeholder="$t('user.select')">
              <el-option v-for="(item,index) in registration"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5"
                class="padt5">
          <!-- 手机号 -->
          <el-form-item :label="$t('user.mobile')">
            <el-input v-model="dataForm.mobile"
                      :placeholder="$t('user.input')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5"
                class="padt5">
          <!-- 邮箱 -->
          <el-form-item :label="$t('user.userEmail')">
            <el-input v-model="dataForm.email"
                      :placeholder="$t('user.input')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="margb10">
        <el-col :span="5"
                class="padt5">
          <!-- 用户ID -->
          <el-form-item :label="$t('user.userID')">
            <el-input v-model="dataForm.userCode"
                      :placeholder="$t('user.input')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5"
                class="padt5">
          <!-- 证件编号 -->
          <el-form-item :label="$t('user.passportIdcard')">
            <el-input v-model="dataForm.idcard"
                      :placeholder="$t('user.input')"
                      maxlength="18"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5"
                class="padt5">
          <!-- 员工号 -->
          <el-form-item :label="$t('user.userCardNo')">
            <el-input v-model="dataForm.userCardNo"
                      :placeholder="$t('user.input')"
                      maxlength="18"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5"
                class="padt5">
          <!-- 权限类型 -->
          <el-form-item :label="$t('user.permissionclassification')">
            <el-select v-model="dataForm.authType"
                       clearable
                       :placeholder="$t('user.select')">
              <el-option v-for="(item,index) in newperClassification"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="margb10">
        <!-- 所在区域 -->
        <el-col :span="5"
                class="padt5">
          <el-form-item :label="$t('organization.area')">
            <el-select v-model="dataForm.areaCode"
                       :placeholder="$t('user.select')"
                       clearable>
              <el-option v-for="(item,index) in areaArr"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 所在城市 -->
        <el-col :span="5"
                class="padt5">
          <el-form-item :label="$t('organization.cityIds')">
            <address-select :level="2"
                            v-model="dataForm.regionIds"
                            :placeholder="$t('user.select')">
            </address-select>
          </el-form-item>
        </el-col>
         <el-col :span="10"
                class="padt5">
          <!-- 角色 -->
          <el-form-item :label="$t('user.role')"
                        style="width:90% !important">
            <el-select v-model="dataForm.roleIdModel"
                       multiple
                       filterable
                       remote
                       reserve-keyword
                       collapse-tags
                       :placeholder="$t('user.input')"
                       :remote-method="roleSearch"
                       @change="roleChange">
              <el-option v-for="item in rolelist"
                         :key="item.roleId"
                         :label="item.roleName"
                         :value="item.roleId">
              </el-option>
            </el-select>
            <el-checkbox v-model="roleCheckedAlready"
                         :disabled="dataForm.roleIdModel.length === 0 && !roleCheckedAlready"
                         @change="roleCheckChange">已选项</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="margb10">
      <!-- 账号状态 -->
       <el-col :span="5"
                class="padt5">
          <el-form-item :label="$t('user.status10')">
            <el-select v-model="dataForm.loginFlag"
                       clearable
                       :placeholder="$t('user.select')">
              <el-option v-for="(item,index) in loginFlag"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 账号禁用时间 -->
         <el-col :span="10"
                class="padt5">
          <el-form-item :label="$t('user.deactivatedTime')"
                        style="width: 100%!important;">
            <el-date-picker v-model="dataForm.deactiveDateModify"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            :start-placeholder="$t('organization.startData')"
                            :end-placeholder="$t('organization.endData')"
                            :clearable="true"
                            :editable='false'
                            style="width: 90%">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 入职日期 -->
      <el-row class="margb10" style="margin-bottom: 5px !important">
        <el-col :span="10"
                class="padt5">
          <el-form-item :label="$t('user.accessionDate')"
                        style="width: 100%!important;">
            <el-date-picker v-model="dataForm.orgJoinDateModify"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            :start-placeholder="$t('organization.startData')"
                            :end-placeholder="$t('organization.endData')"
                            :clearable="true"
                            :editable='false'
                            style="width: 90%">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <!-- 离职日期 -->
        <el-col :span="10"
                class="padt5">
          <el-form-item :label="$t('user.leaveDate')"
                        style="width: 100% !important;">
            <el-date-picker v-model="dataForm.leaveDateModify"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            :start-placeholder="$t('organization.startData')"
                            :end-placeholder="$t('organization.endData')"
                            :clearable="true"
                            :editable='false'
                            style="width: 90%">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="margb10">
        <el-col :span="10"
                class="padt5">
          <!-- 主要职位 -->
          <el-form-item :label="$t('user.position')"
                        style="width:90% !important">
            <el-select v-model="dataForm.jobCodeModel"
                       multiple
                       filterable
                       remote
                       reserve-keyword
                       collapse-tags
                       :placeholder="$t('user.input')"
                       :remote-method="codeSearch"
                       @change="codeChange">
              <el-option v-for="item in positionlist"
                         :key="item.positionCode"
                         :label="item.positionName"
                         :value="item.positionCode">
              </el-option>
            </el-select>
            <el-checkbox v-model="jobCodeCheckedAlready"
                         :disabled="dataForm.jobCodeModel.length === 0 && !jobCodeCheckedAlready"
                         @change="jobCodeCheckChange">已选项</el-checkbox>
          </el-form-item>
        </el-col>
        <!-- 兼职职位 -->
        <el-col :span="10"
                class="padt5">
          <el-form-item :label="$t('user.partJob')"
                        style="width:90% !important">
            <el-select v-model="dataForm.partCodeModel"
                       multiple
                       filterable
                       remote
                       reserve-keyword
                       :placeholder="$t('user.input')"
                       :remote-method="partCodeSearch"
                       @change="partTimeJobCodeChange">
              <el-option v-for="item in partPositionList"
                         :key="item.positionCode"
                         :label="item.positionName"
                         :value="item.positionCode">
              </el-option>
            </el-select>
            <el-checkbox v-model="partTimeJobCodeCheckedAlready"
                         :disabled="dataForm.partCodeModel.length === 0 && !partTimeJobCodeCheckedAlready"
                         @change="partTimeJobCodeCheckChange">已选项</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div style="color: #ccc;">下拉选项仅显示常用的10个备选项，若选择其他内容，可以直接搜索查询</div>
      </el-row>
    </el-form>
    <!-- 展开显示更多 -->
    <ToggleDiv @toggle="toggle"></ToggleDiv>
    <div class="search">
      <!-- 新建 -->
      <el-button type="primary"
                 v-if="$hasPermission('AUTH000034')"
                 @click="changeRevise">{{ $t('user.newlyBuild') }}</el-button>
      <!-- 职位下载 -->
      <a :href="excelDownload"
         download
         class="a-download">职位下载</a>
      <!-- <el-button class="el-button-columnBtn"
                 v-if="$hasPermission('AUTH000034')"
                 @click="changeRevise">职位下载</el-button> -->
      <!-- 批量导入 -->
      <!-- <el-button class="el-button-columnBtn"
                 v-show="false"
                 @click="changeImport">{{ $t('user.batchImport') }}</el-button> -->
      <!-- <el-button class="el-button-columnBtn"
                 @click="exportHandle">{{ $t('user.export') }}</el-button> -->
      <!-- 账号合并 -->
      <!-- <el-button class="el-button-columnBtn"
                 @click="changeMerge">{{ $t('user.accountMerging') }}</el-button> -->
      <!-- 导出 -->
      <!-- <el-button class="el-button-columnBtn">{{ $t('user.export') }}</el-button> -->

      <!-- <el-button class="el-button-columnBtn"
                 @click="cityHandle">地区选择</el-button> -->
      <!-- <el-button class="float-right"
                 v-popover:popover1
                 icon="el-icon-setting">{{ $t('user.setting') }}</el-button> -->
      <!-- <el-popover class="aaa"
                  ref="popover1"
                  placement="left"
                  width="300"
                  v-model="visible">
        <div class="opten-title">
          <em class="el-icon-caret-right"></em>
          {{ $t('user.popTitle') }}
        </div>
        <el-col :span="12"
                class="table-col-check"
                v-for="key in userTableData"
                :key="key.name">
          <el-checkbox v-model="key.isShow">{{ $t('user.'+key.name) }}</el-checkbox>
        </el-col>
        <el-col :span="24">
          <div class="check-all-btn">
            <el-checkbox v-model="checkAll"
                         @change="handleCheckAllChange">{{ $t('checkAll') }}</el-checkbox>
          </div>
          <div class="sure-btn"
               @click="saveTableCol">{{ $t('confirm') }}
          </div>
        </el-col>
      </el-popover> -->
      <!--<el-col :span="24">-->
      <!--<el-button class="float-right" v-popover:popover1  icon="el-icon-setting" >{{ $t('user.setting') }}</el-button>-->
      <!--<el-popover class="aaa" ref="popover1" placement="left" width="300">userTableData-->
      <!--<el-col :span="12" v-for="key in userTableData" :key="key">-->
      <!--<el-checkbox v-model="userTableData.key" @change="showHide(key)">{{ $t('user.brand') }}</el-checkbox>-->
      <!--</el-col>-->
      <!--</el-popover>-->
      <!--</el-col>-->
    </div>
    <div class="table-user table">
      <el-table :data="dataList"
                v-loading="dataListLoading"
                class="user-table"
                style="width: 100%">
        <!-- 组织类型 -->
        <el-table-column prop="orgType"
                         :label="$t('organization.orgType')"
                         :formatter="orgFormatter"
                         min-width="120"
                         show-overflow-tooltip
                         fixed
                         header-align="center">
        </el-table-column>
        <!-- 用户名 -->
        <el-table-column prop="userName"
                         :label="$t('user.name')"
                         min-width="120"
                         show-overflow-tooltip
                         fixed
                         header-align="center">
        </el-table-column>
        <!-- 用户ID -->
        <el-table-column v-if="userTableData[0].isShow"
                         prop="userCode"
                         :label="$t('user.userID')"
                         min-width="130"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column>
        <!-- 员工号 -->
        <!-- <el-table-column v-if="userTableData[0].isShow"
                         prop="userCardNo"
                         :label="$t('user.userCardNo')"
                         width="130"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column> -->
        <!-- 权限分类 -->
        <!-- <el-table-column prop="authType"
                         :formatter="authTypeFormatter"
                         :label="$t('user.permissionclassification')"
                         width="100"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column> -->
        <!-- 公司简称 -->
        <el-table-column v-if="userTableData[2].isShow"
                         prop="abbreviation"
                         :label="$t('user.orgAbbreviation')"
                         min-width="180"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column>
        <!-- 公司全程 -->
        <!-- <el-table-column v-if="userTableData[2].isShow"
                         prop="orgName"
                         :label="$t('user.orgName')"
                         width="180"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column> -->
        <!-- 所属品牌 -->
        <el-table-column v-if="userTableData[1].isShow"
                         prop="brandCode"
                         :formatter="orgTypeFormatter"
                         :label="$t('user.brandCodes')"
                         min-width="100"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column>
        <!-- nscno -->
        <el-table-column v-if="userTableData[6].isShow"
                         prop="nscNo"
                         :label="$t('user.nscno')"
                         min-width="150"
                         show-overflow-tooltip
                         align="center"
                         header-align="center">
        </el-table-column>
        <!-- 网点类型 -->
        <el-table-column v-if="userTableData[6].isShow"
                         prop="networkType"
                         :formatter="networkTypeFormatter"
                         :label="$t('user.outletType')"
                         min-width="120"
                         show-overflow-tooltip
                         align="center"
                         header-align="center">
        </el-table-column>
        <!-- 职位 -->
        <el-table-column v-if="userTableData[4].isShow"
                         prop="positionName"
                         :label="$t('user.position')"
                         min-width="150"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column>
        <!-- 角色 -->
        <el-table-column v-if="userTableData[5].isShow"
                         prop="roleName"
                         :label="$t('user.role')"
                         min-width="170"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column>
        <!-- 证件类型 -->
        <!-- <el-table-column prop="idType"
                         :label="$t('user.idtype')"
                         width="130"
                         :formatter="idTypeFormatter"
                         show-overflow-tooltip
                         align="center"
                         header-align="center">
        </el-table-column> -->
        <!-- 证件编号 -->
        <el-table-column prop="idcard"
                         :label="$t('user.passportIdcard')"
                         min-width="160"
                         :formatter="idcardFormatter"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column>
        <!-- 手机号 -->
        <el-table-column v-if="userTableData[6].isShow"
                         prop="mobile"
                         :label="$t('user.mobile')"
                         min-width="130"
                         :formatter="mobileFormatter"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column>
        <!-- 邮箱 -->
        <el-table-column v-if="userTableData[8].isShow"
                         prop="email"
                         :label="$t('user.userEmail')"
                         min-width="180"
                         :formatter="emailFormatter"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column>
        <!-- 所在城市 -->
        <el-table-column prop="regionIds"
                         :formatter="cityFormatter"
                         :label="$t('organization.cityIds')"
                         min-width="130"
                         header-align="center"
                         show-overflow-tooltip
                         key="16">
        </el-table-column>
        <!-- 在职状态 -->
        <el-table-column v-if="userTableData[7].isShow"
                         prop="jobStatus"
                         :label="$t('user.incumbency')"
                         min-width="100"
                         align="center"
                         header-align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.jobStatus == '10'">{{$t('user.move')}}</span>
            <!-- 不活动 -->
            <span v-if="scope.row.jobStatus == '20'">{{$t('user.unmove')}}</span>
          </template>
        </el-table-column>
        <!-- 入职状态 -->
        <el-table-column v-if="userTableData[3].isShow"
                         prop="registrationApprovaStatus"
                         :label="$t('user.registration')"
                         :formatter="registrationApprovaStatusFormatter"
                         min-width="100"
                         show-overflow-tooltip
                         align="center"
                         header-align="center">
        </el-table-column>
        <!-- 创建人 -->
        <el-table-column v-if="userTableData[10].isShow"
                         prop="createUserName"
                         :label="$t('user.buildmen')"
                         min-width="120"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column>
        <!-- 最后登录时间 -->
        <el-table-column v-if="userTableData[11].isShow"
                         prop="lastLoginTime"
                         :label="$t('user.lastlogintime')"
                         min-width="180"
                         show-overflow-tooltip
                         align="center"
                         header-align="center">
        </el-table-column>
        <!-- 是否允许登录 -->
        <el-table-column prop="loginFlag"
                         :label="$t('user.status10')"
                         :formatter="loginFlagFormatter"
                         min-width="110"
                         header-align="center"
                         show-overflow-tooltip
                         align="center">
        </el-table-column>
         <!-- 禁用原因 -->
        <el-table-column prop="deactivatedReason"
                         :label="$t('user.deactivatedReason')"
                         min-width="180"
                         show-overflow-tooltip
                         align="center"
                         header-align="center">
        </el-table-column>
        <!-- 禁用开始时间 -->
        <el-table-column prop="deactivatedTime"
                         :label="$t('user.deactivatedTime')"
                         min-width="180"
                         show-overflow-tooltip
                         align="center"
                         header-align="center">
        </el-table-column>
        <!-- 操作 -->
        <el-table-column fixed="right"
                         :label="$t('user.operation')"
                         width="120"
                         align="center">
          <template slot-scope="scope">
            <!-- 查看 -->
            <span class="el-dropdown-link"
                  v-if="scope.row.registrationApprovaStatus === '50' && $hasPermission('AUTH000036')"
                  @click="changeCheck(scope.row.userId)">{{ $t('view') }}</span>
            <span class="span-disable"
                  v-else>{{ $t('view') }}</span>
            <el-divider direction="vertical"></el-divider>
            <el-dropdown trigger="click"
                         v-if="scope.row.registrationApprovaStatus === '50'"
                         placement="bottom">
              <span class="el-dropdown-link">
                {{ $t('user.operation') }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!-- 查看 -->
                <!-- <el-dropdown-item v-if="scope.row.registrationApprovaStatus === '50' && $hasPermission('AUTH000036')"
                                  @click.native="changeCheck(scope.row.userId)">{{ $t('view') }}</el-dropdown-item> -->
                <!-- 修改 -->
                <el-dropdown-item v-if="scope.row.agreePolicy !== '20' && scope.row.registrationApprovaStatus === '50' && $hasPermission('AUTH000035') && scope.row.userId !== 1"
                                  @click.native="changeBuild(scope.row)">{{ $t('update') }}</el-dropdown-item>
                <!-- 转岗 -->
                <el-dropdown-item @click.native="transfer(scope.row, scope.row.userId, scope.row.orgType)"
                                  v-if="scope.row.agreePolicy !== '20' && scope.row.jobStatus !== '20' && $hasPermission('AUTH000039') && scope.row.userId !== 1">
                  {{ $t('user.transfer') }}
                </el-dropdown-item>
                <!-- 离职 -->
                <el-dropdown-item v-if="scope.row.agreePolicy !== '20' && $hasPermission('AUTH000037') && scope.row.jobStatus !== '20' && scope.row.userId !== 1 && scope.row.orgType && scope.row.orgType !== '10'"
                                  @click.native="leaveOfficeNative(scope.row, scope.row.userId)">
                  {{ $t('user.leaveOffice') }}
                </el-dropdown-item>
                 <!-- 变更权限 -->
                <el-dropdown-item @click.native="authApply(scope.row, scope.row.userId, scope.row.orgType)"
                                  v-if="scope.row.agreePolicy !== '20' && scope.row.jobStatus !== '20' && $hasPermission('AUTH000111') && scope.row.userId !== 1">
                  {{ $t('user.authApply') }}
                </el-dropdown-item>
                <!-- 下载简历 -->
                <el-dropdown-item v-if="$hasPermission('AUTH000036') && scope.row.userId !== 1"
                                  :class="!(scope.row.agreePolicy !== '20' && scope.row.registrationApprovaStatus === '50') ? 'item-disabled':''"
                                  @click.native="downloadPDF(scope.row.userId,!(scope.row.agreePolicy !== '20' && scope.row.registrationApprovaStatus === '50'))">{{ $t('user.downloadResume') }}
                </el-dropdown-item>
                <!-- 查看简历 -->
                <el-dropdown-item v-if="$hasPermission('AUTH000036') && scope.row.userId !== 1"
                                  :class="!(scope.row.agreePolicy !== '20' && scope.row.registrationApprovaStatus === '50') ? 'item-disabled':''"
                                  @click.native="findResume(scope.row.userId,!(scope.row.agreePolicy !== '20' && scope.row.registrationApprovaStatus === '50'))">{{ $t('user.findResume') }}
                </el-dropdown-item>
                <!-- 培训记录 -->
                <!-- <el-dropdown-item  v-if="scope.row.registrationApprovaStatus === '50' && $hasPermission('AUTH000036') && scope.row.userId !== 1"
                                  >{{ $t('user.trainingRecord') }}
                </el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
            <span class="el-dropdown-link"
                  v-if="scope.row.registrationApprovaStatus !== '50'"
                  @click.prevent="operationClick(scope.row.registrationApprovaStatus)">
              {{ $t('user.operation') }}<em class="el-icon-caret-bottom el-icon--right"></em>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block"
         style="float: right;margin-top: 20px;margin-right: 30px; margin-bottom: 20px">
      <el-pagination @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle"
                     :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </div>
    <!-- 转岗 -->
    <transferNewPost v-if="transferNewPostVisible"
                     ref="transferNewPost"
                     @refreshDataList="getDataListMerge"></transferNewPost>
    <UserBwmTransfer v-if="userBwmTransferable"
                     ref="UserBwmTransfer"
                     @refreshBwmDataList="getDataListMerge"></UserBwmTransfer>
    <!-- 变更权限 -->
    <UserAuthApply v-if="userAuthApplyVisible"
                   ref="UserAuthApply"
                   @refreshAuthDataList="getDataListMerge"></UserAuthApply>
    <UserAuthApplyMain v-if="userAuthApplyMainVisible"
                   ref="UserAuthApplyMain"
                   @refreshAuthMainDataList="getDataListMerge"></UserAuthApplyMain>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddressSelect from '../../../components/address-select/index.vue'
import Vue from 'vue'
import ToggleDiv from '@/components/toggle-div'
import TransferNewPost from './user-transfer-to-new-post'
import UserBwmTransfer from './user-bwm-transfer'
import UserAuthApply from './user-auth-apply'
import UserAuthApplyMain from './user-auth-apply-main'
import { getRegionNameList } from '@/utils'
import {Decrypt,Encrypt} from '@/utils/aec'
import AesUtil from "@/utils/aes_utils";
export default {
  mixins: [mixinViewModule],
  name: 'user',
  data() {
    let _this = this
    return {
      // 获取列表信息
      mixinViewModuleOptions: {
        getDataListURL: '/sys/commuser/list',
        getDataListIsPage: true
      },
      excelDownload: '',
      leaveOfficeShow: false,
      transferNewPostVisible: false,
      userBwmTransferable: false,
      userAuthApplyVisible: false,
      userAuthApplyMainVisible: false,
      // 角色list
      rolelist: [],
      // 职位list
      positionlist: [],
      // 兼职list
      partPositionList: [],
      // 公司list
      results: [],
      // 在职状态
      jobStatus: _this.enums['jobStatus'],
      // 审批流程
      registration: _this.enums['registration'],
      // 权限分类
      perClassification: _this.enums['perClassification'],
      newperClassification: [],
      // 品牌
      brandCode: _this.enums['brandCode'],
      // 组织类型
      userorgType: _this.enums['orgType'],
      // 组织类型
      neworgType: [],
      // 网点类型
      networkType: _this.enums['networkType'],
      // 品牌
      brandArr: _this.enums['brandCode'],
      // 所在区域
      areaArr: this.enums['area'],
      //是否允许登录
      loginFlag: _this.enums['loginFlag'],

      // 查询条件
      dataForm: {
        orgType: '',
        orgId: '',
        userName: '',
        userCode: '',
        jobStatus: '',
        registrationApprovaStatus: '50',
        idcard: '',
        authType: '',
        userCardNo: '',
        mobile: '',
        email: '',
        brandCode: '',
        areaCode: '',
        regionIds: [],
        jobCodeModel: [],
        roleIdModel: [],
        partCodeModel: [],
        orgJoinDateModify: [],
        leaveDateModify: [],
        deactiveDateModify: [],
      },
      // 列表list
      dataList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      // 展示更多
      showBrand: true,
      userTableData: [],
      isShow: false,
      checkAll: false,
      // 设置按钮pop状态
      visible: false,
      isAgreePolicy: true,
      jobCodeCheckedAlready: false, // 主要职位已选
      jobCodeChangeOld: [], // 上次主要职位已选项
      jobCodeChangeVal: [], // change事件传递过来的已选项
      jobCodeSelectAlready: [], // 主要职位已选项
      roleCheckedAlready: false, // 主要职位已选
      roleChangeOld: [], // 上次主要职位已选项
      roleChangeVal: [], // change事件传递过来的已选项
      roleSelectAlready: [], // 主要职位已选项
      partTimeJobCodeCheckedAlready: false, // 主要职位已选
      partTimeJobCodeChangeOld: [], // 上次主要职位已选项
      partTimeJobCodeChangeVal: [], // change事件传递过来的已选项
      partTimeJobCodeSelectAlready: [] // 主要职位已选项
    }
  },
  /*beforeMount () {
    let arry = []
    for (let i = 0; i < this.areaArr.length; i++) {
      if (this.areaArr[i].dictStatus == '1') {
        arry.push(this.areaArr[i])
      }
    }
      this.areaArr = arry
  },*/
  methods: {
    changeOrgType() {
      // this.codeSearch('')
      // this.roleSearch('')
    },
    findResume(id, disabled) {
      if (disabled) {
        return false
      }
      let query = {}
      const base64url = require('base64-url')
      let aes = new AesUtil()
      let userId = '';
      if(id === ''){
        userId = '';
      }else {
        userId = base64url.encode(aes.encrypt(id + ''))
      }
      console.info("userId------"+userId)
      query.userId = id
      let name = 'talent-talentpool-view'
      this.$router.push({
        name: 'acdc-resume-resumePDF',
        query: {
          userId: userId,
          isSysUser:'1'
        }
      })
    },
    // 下载PDF
    downloadPDF(id, disabled) {
      if (disabled) {
        return false
      }
      this.$request.downloadPDF('/talent/talentpool/newExportPDF', '员工简历信息', {
        userIds: Encrypt(id)
      })
      // let a = document.createElement('a')
      // a.target = '_blank'
      // a.href = window.SITE_CONFIG['apiURL'] + 'http://220.249.93.211:7001/sys/external/downloadResume?userId=3'
      // a.click()
      // var elemIF = document.createElement('iframe')
      // elemIF.src = window.SITE_CONFIG['apiBaseURL'] + '/talent/talentpool/exportPDF?userId=' + id
      // elemIF.style.display = 'none'
      // document.body.appendChild(elemIF)
      // let url = '/sys/commmail/downloadResume'
      // this.$request.getDIY(url, { userId: 3 }).then((res, total, code, data) => {
      // }).catch(() => { })
    },
    // 证件编号加密 身份证只加密出生日期，护照号保留第一位和后三位
    idcardFormatter(row) {
      if(!row.idcard){
        return row.idcard;
      }
      if (row.idType === '10') {
        let a = row.idcard.substring(0, 6)
        let b = row.idcard.substr(row.idcard.length - 4)
        return `${a}⁎⁎⁎⁎⁎⁎⁎⁎${b}`
      } else if (row.idType === '20') {
        let a = row.idcard.substring(0, 1)
        let b = row.idcard.substr(row.idcard.length - 3)
        let encryption = ''
        for (let i = 0; i < row.idcard.length - 4; i++) {
          encryption += '⁎'
        }
        return `${a}${encryption}${b}`
      } else {
        return row.idcard
      }
    },
    // 手机号加密 只显示后四位
    mobileFormatter(row) {
      if (row.mobile && row.mobile !== '') {
        let encryption = ''
        for (let i = 0; i < row.mobile.length - 4; i++) {
          encryption += '⁎'
        }
        let mobile = encryption + row.mobile.substr(row.mobile.length - 4)
        return mobile
      } else {
        return row.mobile
      }
    },
    // 邮箱加密 @之前如果超过2位，显示后两位，如果不超过两位，全部隐藏
    emailFormatter(row) {
      if (row.email && row.email !== '') {
        let index = row.email.split('@')
        let partOne = index[0]
        let partTwo = index[1]
        let encryption = ''
        if (partOne.length <= 2) {
          for (let i = 0; i < partOne.length; i++) {
            encryption += '⁎'
          }
          return encryption + '@' + partTwo
        } else {
          for (let i = 0; i < partOne.length - 2; i++) {
            encryption += '⁎'
          }
          let email = partOne.substring(0, 2) + encryption
          return email + '@' + partTwo
        }
      } else {
        return row.email
      }
    },
    // 城市格式返回
    cityFormatter(row) {
      if (row.regionIds) {
        return getRegionNameList(row.regionIds)
      } else {
        return ''
      }
    },
    // 品牌回显
    orgTypeFormatter(row) {
      // return Vue.filter('coverEnum')(row.brandCode, 'brandCode')
      return Vue.filter('coverEnumList')(row.brandCode, 'brandCode', ',')
    },
    // 所在区域
    areaCodeFormatter(row) {
      return Vue.filter('coverEnum')(row.areaCode, 'area')
    },
    // 网点类型
    networkTypeFormatter(row) {
      return Vue.filter('coverEnum')(row.networkType, 'networkType')
    },
    authTypeFormatter(row) {
      // 权限类型
      return Vue.filter('coverEnum')(row.authType, 'perClassification')
    },
    educationFormatter(row) {
      // 学历
      return Vue.filter('coverEnum')(row.educationCode, 'educationCode')
    },
    registrationApprovaStatusFormatter(row) {
      // 审批流程
      return Vue.filter('coverEnum')(row.registrationApprovaStatus, 'registration')
    },
    idTypeFormatter(row) {
      // 证件类型
      return Vue.filter('coverEnum')(row.idType, 'idType')
    },
    orgFormatter(row) {
      // 组织类型
      return Vue.filter('coverEnum')(row.orgType, 'orgType')
    },
    // 入职日期
    openDateFormatter(row) {
      if (row.orgJoinDate !== '' && row.orgJoinDate !== null) {
        return Vue.filter('formatDateNoTime')(row.orgJoinDate)
      } else {
        return ''
      }
    },
    // 离职日期
    leaveDateFormatter(row) {
      if (row.leaveDate !== '' && row.leaveDate !== null) {
        return Vue.filter('formatDateNoTime')(row.leaveDate)
      } else {
        return ''
      }
    },
    loginFlagFormatter(row) {
      // 审批流程
      return Vue.filter('coverEnum')(row.loginFlag, 'loginFlag')
    },
    // 获取公司信息
    querySearch(queryString) {
      this.$request.get('/sys/org/selectOrgList',
        {
          name: queryString,
          orgType: this.dataForm.orgType
        }
      ).then((res, total, code, data) => {
        this.results = res
        this.results = this.results.map(item => {
          item['value'] = item.name
          return item
        })
      }).catch(() => { })
    },
    toggle(val) {
      this.isShow = val
    },
    // 跳转到查看页面
    changeCheck(userid) {
      const base64url = require('base64-url')
      let aes = new AesUtil()
      let userId = base64url.encode(aes.encrypt(userid + ''))
      this.$router.push({
        name: 'sys-check',
        query: { userId }
      })
    },
    // 操作
    operationClick(id) {
      if (id !== '50') {
        this.$alert(this.$t('user.registrationApprovaStatus'), this.$t('prompt.title'))
      }
    },
    // 查询
    getDataListMerge() {
      this.page = 1
      let newJobs = ''
      // 职位多选
      if (this.dataForm.jobCodeModel.length > 0) {
        this.dataForm.jobCodeModel.forEach((element, index) => {
          if (index !== this.dataForm.jobCodeModel.length - 1) {
            newJobs += element + ','
          } else {
            newJobs += element
          }
        })
      }
      this.dataForm.jobCodes = newJobs
      // 角色多选
      let newRoles = ''
      if (this.dataForm.roleIdModel.length > 0) {
        this.dataForm.roleIdModel.forEach((element, index) => {
          if (index !== this.dataForm.roleIdModel.length - 1) {
            newRoles += element + ','
          } else {
            newRoles += element
          }
        })
      }
      this.dataForm.roleIds = newRoles
      // 兼职多选
      let newPartJobs = ''
      if (this.dataForm.partCodeModel.length > 0) {
        this.dataForm.partCodeModel.forEach((element, index) => {
          if (index !== this.dataForm.partCodeModel.length - 1) {
            newPartJobs += element + ','
          } else {
            newPartJobs += element
          }
        })
      }
      this.dataForm.partTimeJobCodes = newPartJobs
      // 入职与离职日期
      if (this.dataForm.orgJoinDateModify && this.dataForm.orgJoinDateModify !== '') {
        if (this.dataForm.orgJoinDateModify.length === 2) {
          this.dataForm.orgJoinDateStart = this.dataForm.orgJoinDateModify[0]
          this.dataForm.orgJoinDateEnd = this.dataForm.orgJoinDateModify[1]
        } else {
          this.dataForm.orgJoinDateStart = ''
          this.dataForm.orgJoinDateEnd = ''
        }
      } else {
        this.dataForm.orgJoinDateStart = ''
        this.dataForm.orgJoinDateEnd = ''
      }
      if (this.dataForm.leaveDateModify && this.dataForm.leaveDateModify !== '') {
        if (this.dataForm.leaveDateModify.length === 2) {
          this.dataForm.leaveDateStart = this.dataForm.leaveDateModify[0]
          this.dataForm.leaveDateEnd = this.dataForm.leaveDateModify[1]
        } else {
          this.dataForm.leaveDateStart = ''
          this.dataForm.leaveDateEnd = ''
        }
      } else {
        this.dataForm.leaveDateStart = ''
        this.dataForm.leaveDateEnd = ''
      }
      if (this.dataForm.deactiveDateModify && this.dataForm.deactiveDateModify !== '') {
        if (this.dataForm.deactiveDateModify.length === 2) {
          this.dataForm.deactiveDateStart = this.dataForm.deactiveDateModify[0]
          this.dataForm.deactiveDateEnd = this.dataForm.deactiveDateModify[1]
        } else {
          this.dataForm.deactiveDateStart = ''
          this.dataForm.deactiveDateEnd = ''
        }
      } else {
        this.dataForm.deactiveDateStart = ''
        this.dataForm.deactiveDateEnd = ''
      }
      this.getDataList()
    },
    // 批量导出
    // exportHandle () {
    //   // download 参数 url, params, 报表名
    //   this.$request.download('/sys/commuser/export', this.$t('user.userExport'),
    //     {
    //       ...this.dataForm,
    //       page: this.page,
    //       limit: this.limit
    //     }
    //   )
    // },
    // 跳转到合并界面
    changeMerge() {
      this.$router.push({
        name: 'sys-merge'
      })
    },
    // 跳转到新建修改界面
    changeBuild(row) {
      // this.$request.get(`/sys/commuser/permissible`,
      //   {
      //     userId: userId
      //   }
      // ).then((res, total, code, data) => {
      //   if (code === 1) {
      //   } else {
      //   }
      // }).catch(() => { })
      const base64url = require('base64-url')
      let aes = new AesUtil()
      let userId = base64url.encode(aes.encrypt(row.userId + ''))
      this.$router.push({
        name: 'sys-new-build',
        query: {
          userId: userId,
          jobStatus: row.jobStatus
        }
      })
      // 广播通知需要清空表单
      this.$eventHub.$emit(this.GLOBAL.ACTIVATED_USER, 'activated')
    },
    changeRevise() {
      // 广播通知需要清空表单
      this.$eventHub.$emit(this.GLOBAL.ACTIVATED_USER, 'activated')
      this.$router.push({
        name: 'sys-new-build'
      })
    },
    // 跳转到导入页面
    changeImport() {
      this.$router.push({
        path: 'sys-leading-in'
      })
    },
    // 跳转地区管理
    cityHandle() {
      this.$router.push({
        path: '/sys/commregion'
      })
    },
    // 重置
    again() {
      this.dataForm = {
        orgType: '',
        orgId: '',
        userName: '',
        userCode: '',
        jobStatus: '',
        registrationApprovaStatus: '50',
        idcard: '',
        authType: '',
        userCardNo: '',
        mobile: '',
        email: '',
        brandCode: '',
        areaCode: '',
        regionIds: [],
        jobCodeModel: [],
        roleIdModel: [],
        partCodeModel: [],
        orgJoinDateModify: [],
        leaveDateModify: [],
        deactiveDateModify: [],
      }
      this.jobCodeCheckedAlready = false
      this.jobCodeChangeOld = []
      this.jobCodeChangeVal = []
      this.jobCodeSelectAlready = []
      this.roleCheckedAlready = false
      this.roleChangeOld = []
      this.roleChangeVal = []
      this.roleSelectAlready = []
      this.partTimeJobCodeCheckedAlready = false
      this.partTimeJobCodeChangeOld = []
      this.partTimeJobCodeChangeVal = []
      this.partTimeJobCodeSelectAlready = []
      this.codeSearch('')
      this.roleSearch('')
      this.partCodeSearch('')
      this.getDataListMerge()
    },
    // 展示更多
    showHide(key) {
      switch (key) {
        case 'showBrand': this.showBrand = !this.showBrand
          break
      }
    },
    // 点击已选项
    jobCodeCheckChange(val) {
      if (val) { // 已选
        let positionlist = JSON.parse(JSON.stringify(this.jobCodeSelectAlready))
        this.positionlist = []
        this.jobCodeChangeVal.forEach(item => {
          let entry = positionlist.find(item1 => {
            if (item1.positionCode === item) {
              return item1
            }
          })
          this.positionlist.push(entry)
        })
      } else {
        this.codeSearch('')
      }
    },
    // 选择主要职位，维护已选项
    codeChange(val) {
      this.jobCodeChangeVal = val
      if (val.length > this.jobCodeChangeOld.length) {
        let positionCode = val[val.length - 1]
        for (let index in this.positionlist) {
          if (positionCode === this.positionlist[index].positionCode) {
            this.jobCodeSelectAlready.push(this.positionlist[index])
          }
        }
      }
      this.jobCodeChangeOld = val
    },
    // 主要职位搜索
    codeSearch(query) {
      this.$request.post('/sys/role/queryPositionByType',
        {
          status: '20',
          positionName: query,
          orgType: this.dataForm.orgType
        }
      ).then((res, total, code, data) => {
        this.positionlist = res
      }).catch(() => { })
    },
    // 点击已选项
    roleCheckChange(val) {
      if (val) { // 已选
        let rolelist = JSON.parse(JSON.stringify(this.roleSelectAlready))
        this.rolelist = []
        this.roleChangeVal.forEach(item => {
          let entry = rolelist.find(item1 => {
            if (item1.roleId === item) {
              return item1
            }
          })
          this.rolelist.push(entry)
        })
      } else {
        this.roleSearch('')
      }
    },
    // 选择主要职位，维护已选项
    roleChange(val) {
      this.roleChangeVal = val
      if (val.length > this.roleChangeOld.length) {
        let roleId = val[val.length - 1]
        for (let index in this.rolelist) {
          if (roleId === this.rolelist[index].roleId) {
            this.roleSelectAlready.push(this.rolelist[index])
          }
        }
      }
      this.roleChangeOld = val
    },
    // 角色搜索
    roleSearch(query) {
      this.$request.get('/sys/commuser/getRoleList',
        {
          roleName: query,
          orgType: this.dataForm.orgType
        }
      ).then((res, total, code, data) => {
        this.rolelist = res
      }).catch(() => { })
    },
    // 点击已选项
    partTimeJobCodeCheckChange(val) {
      if (val) { // 已选
        let partPositionList = JSON.parse(JSON.stringify(this.partTimeJobCodeSelectAlready))
        this.partPositionList = []
        this.partTimeJobCodeChangeVal.forEach(item => {
          let entry = partPositionList.find(item1 => {
            if (item1.positionCode === item) {
              return item1
            }
          })
          this.partPositionList.push(entry)
        })
      } else {
        this.partCodeSearch('')
      }
    },
    // 选择主要职位，维护已选项
    partTimeJobCodeChange(val) {
      this.partTimeJobCodeChangeVal = val
      if (val.length > this.partTimeJobCodeChangeOld.length) {
        let positionCode = val[val.length - 1]
        for (let index in this.partPositionList) {
          if (positionCode === this.partPositionList[index].positionCode) {
            this.partTimeJobCodeSelectAlready.push(this.partPositionList[index])
          }
        }
      }
      this.partTimeJobCodeChangeOld = val
    },
    // 兼职搜索
    partCodeSearch(query) {
      this.$request.post('/sys/role/queryPositionByType',
        {
          partTimeJobFlag: '10',
          status: '20',
          positionName: query,
          orgType: this.dataForm.orgType
        }
      ).then((res, total, code, data) => {
        this.partPositionList = res
      }).catch(() => { })
    },
    saveTableCol() {
      this.visible = false
      this.setStorage('this.GLOBAL.USER_TABLE', JSON.stringify(this.userTableData))
    },
    handleCheckAllChange() {
      this.userTableData.forEach(element => {
        element.isShow = this.checkAll
      })
    },
    // 转岗
    transfer(row, id, orgType) {
      // 入职当天不能转岗
      this.$request.get('/sys/getServerTime').then((res, total, code, data) => {
        let nowDate = res.date
        if (row.orgJoinDate && row.orgJoinDate !== '' && new Date(Date.parse(row.orgJoinDate.replace(/-/g, '/'))).getTime() === new Date(Date.parse(nowDate.replace(/-/g, '/'))).getTime()) {
          this.$alert(this.$t('user.transferErrorMessage'), this.$t('prompt.title'))
          return false
        }
        if (orgType === '60') {
          // 判断用户是否可以转岗
          this.$request.get('/sys/position/transfer/permissible',
            {
              userId: id
            }
          ).then((res, total, code, data) => {
            if (code === 1) {
              this.$confirm(this.$t('position.transferConfirm'), this.$t('prompt.title'), {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then(() => {
                   this.transferNewPostVisible = true
                    this.$nextTick(() => {
                      this.$refs.transferNewPost.id = id
                      this.$refs.transferNewPost.init()
                    })
              }).catch(() => {
              })
            }
          }).catch(() => { })
        } else if (orgType === '10' || orgType === '20' || orgType === '30' || orgType === '40') {
          // 判断用户是否可以转岗
          this.$request.get('/sys/position/transfer/permissible',
            {
              userId: id
            }
          ).then((res, total, code, data) => {
            if (code === 1) {
              this.$confirm(this.$t('position.transferConfirm'), this.$t('prompt.title'), {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then(() => {
                  this.userBwmTransferable = true
                  this.$nextTick(() => {
                    this.$refs.UserBwmTransfer.id = id
                    this.$refs.UserBwmTransfer.init()
                  })
              }).catch(() => {
              })
            }
          }).catch(() => { })
        }
      }).catch(() => { })
    },

    // 变更权限
    authApply(row, id, orgType) {
      // 入职当天不能变更权限
      this.$request.get('/sys/getServerTime').then((res, total, code, data) => {
        let nowDate = res.date
        if (row.orgJoinDate && row.orgJoinDate !== '' && new Date(Date.parse(row.orgJoinDate.replace(/-/g, '/'))).getTime() === new Date(Date.parse(nowDate.replace(/-/g, '/'))).getTime()) {
          // 不再检查当天入职时不允许权限变更 2021-05-10
          // this.$alert(this.$t('user.authApplyErrorMessage'), this.$t('prompt.title'))
          // return false
        }
        // 判断用户是否可以变更权限
        if (orgType === '60') {
          const base64url = require('base64-url')
          let aes = new AesUtil()
          let userId = '';
          if(id === ''){
            userId = '';
          }else {
            userId = base64url.encode(aes.encrypt(id + ''))
          }
          this.$request.get('/sys/commAuthApply/allowApplyMT',
            {
              userId: userId
            }
          ).then((res, total, code, data) => {
            if (code === 1) {
              this.userAuthApplyVisible = true
              this.$nextTick(() => {
                this.$refs.UserAuthApply.id = id
                this.$refs.UserAuthApply.init()
              })
            }
          }).catch(() => { })
        } else if (orgType === '10' || orgType === '20' || orgType === '30' || orgType === '40') {
          const base64url = require('base64-url')
          let aes = new AesUtil()
          let userId = '';
          if(id === ''){
            userId = '';
          }else {
            userId = base64url.encode(aes.encrypt(id + ''))
          }
          this.$request.get('/sys/commAuthApply/allowApplyMT',
            {
              userId: userId
            }
          ).then((res, total, code, data) => {
            if (code === 1) {
              this.userAuthApplyMainVisible = true
              this.$nextTick(() => {
                this.$refs.UserAuthApplyMain.id = id
                this.$refs.UserAuthApplyMain.init()
              })
            }
          }).catch(() => { })
        }
      }).catch(() => { })
    },
    // 跳转离职页面
    leaveOfficeNative(row, id) {
      // 入职当天不能转岗
      this.$request.get('/sys/getServerTime').then((res, total, code, data) => {
        let nowDate = res.date
        if (row.orgJoinDate && row.orgJoinDate !== '' && new Date(Date.parse(row.orgJoinDate.replace(/-/g, '/'))).getTime() === new Date(Date.parse(nowDate.replace(/-/g, '/'))).getTime()) {
          this.$alert(this.$t('user.dissionErrorMessage'), this.$t('prompt.title'))
          return false
        }
        const base64url = require('base64-url')
        let aes = new AesUtil()
        let userId = '';
        if(id === ''){
          userId = '';
        }else {
          userId = base64url.encode(aes.encrypt(id + ''))
        }
        this.$request.get(`/sys/dimission/permissibleMT`,
          {
            userId: userId
          }
        ).then((res, total, code, data) => {
          if (code === 1) {
            this.$router.push({
              name: 'sys-user-leave-office',
              query: {
                userId: id
              }
            })
          } else {
            this.$alert(this.$t('user.userLeaveDoing'), this.$t('prompt.title'))
          }
        }).catch(() => { })
      }).catch(() => { })
    }
  },
  components: {
    AddressSelect,
    ToggleDiv,
    TransferNewPost,
    UserBwmTransfer,
    UserAuthApply,
    UserAuthApplyMain
  },
  created() {
    let userTable = this.getStorage('this.GLOBAL.USER_TABLE')
    let userTableData = []
    if (userTable) {
      userTableData = JSON.parse(userTable)
    } else {
      userTableData = this.$store.state.userTable.userTable
    }
    this.userTableData = userTableData
  },
  mounted() {
    // 获取职位excel下载地址
    this.$request.get('/sys/config/list?paramKey=POSITION_CODE').then((res, total, code, data) => {
      this.excelDownload = res[0].paramValue
    }).catch(() => { })
    this.neworgType = JSON.parse(JSON.stringify(this.userorgType))
    if (this.neworgType.length === 6) {
      this.neworgType.splice(4, 1)
    }
    this.newperClassification = JSON.parse(JSON.stringify(this.perClassification))
    for (let index in this.newperClassification) {
      if (this.newperClassification[index].code + '' === '50') {
        this.newperClassification.splice(index, 1)
      }
    }
    this.codeSearch('')
    this.roleSearch('')
    this.partCodeSearch('')
  }
}
</script>

<style lang="scss" scoped>
.search {
  margin-bottom: 10px;
}
.sure-btn {
  cursor: pointer;
  background: #1c69d3;
  color: #fff;
  width: 60px;
  font-size: 12px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  float: right;
  margin-top: 20px;
}
li {
  list-style: none;
}
.float-right {
  float: right;
}
.el-autocomplete {
  width: 100% !important;
}
// .table-user {
//   max-width: 1493px;
// }
.check-all-btn {
  float: left;
  margin-top: 20px;
}
.table-col-check {
  margin-bottom: 10px;
}
.el-input {
  height: 34px !important;
  line-height: 34px !important;
}
.el-input__inner {
  height: 34px !important;
  line-height: 34px !important;
}
.registrationApprovaStatus {
  color: red;
  padding: 0;
}
.a-download {
  margin-left: 20px;
  text-decoration: none;
}
.span-disable {
  // pointer-events: none;
  cursor: not-allowed;
  color: darkgrey;
}
.item-disabled {
  color: #aaa;
}
</style>
